/**
 * Devuelve un substring del string que va despues del pattern, si el pattern no existe en el string devuelve cadena vacía
 *
 *
 * @param {string} str el string original
 * @param {string} pattern el string que queremos buscar
 * @returns {string}
 */
export function substringAfter(str, pattern) {
  if (typeof str !== 'string') {
    throw new TypeError(`str ${str} parameter is not a string`);
  }
  if (typeof pattern !== 'string') {
    throw new TypeError(`pattern ${pattern} parameter is not a string`);
  }
  if (str.indexOf(pattern) === -1) {
    return '';
  }
  return str.substring(str.indexOf(pattern) + pattern.length);
}
